
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Signup from "./components/signup/Sign.jsx"
import Login from "./components/login/Login.jsx"
import Quiz from "./components/Quiz/Quiz"
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
function App() {
 
  return (
    <div>
      <Router>
        <Switch>
        {/* <Signup/> 
        <Login/> */}
    <Route exact path="/log"> <Login/> </Route>
   <Route exact path="/quiz"> <Quiz/> </Route>
    <Route exact path="/"> <Signup/> </Route>
        </Switch>
        </Router>
    </div>
  );
}

export default App;
